<template>
  <div class="mila-remember-mv-container">
    <h1>虛擬藝人 米拉蜜</h1>
  </div>
</template>

<script>
export default {
  name: 'MilaRememberMV'
}
</script>

<style scoped>
.mila-remember-mv-container {
  padding: 20px;
  text-align: center;
}

h1 {
  color: #ff69b4;
  margin-bottom: 20px;
}
</style>
